import IntegrationCallStateOverviewResourceModel from '../../generated/types/model/resource/IntegrationCallStateOverviewResourceModel';

export default class IntegrationCallStateOverviewResourceViewModel extends IntegrationCallStateOverviewResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
